<template>
  <div class="page-layout">
    <slot />
  </div>
</template>

<script setup>
import { FONTS } from '@/styles/brand'
</script>

<style scoped>
.page-layout {
  min-height: 100vh;
  background:
    linear-gradient(135deg, rgba(102, 126, 234, 0.8) 0%, rgba(20, 64, 154, 0.8) 50%, rgba(31, 31, 79, 0.9) 100%),
    url('@/assets/nordeus-3840x1080-pattern_new.jpg') no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
  position: relative;
  font-family: v-bind('FONTS.GOOGLE');
}

.page-layout::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="50" cy="50" r="0.5" fill="%23ffffff" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>') repeat;
  pointer-events: none;
}
</style>